<template>
  <div>
    <v-toolbar elevation="1" dark dense color="highlight" flat class="sticky">
      <v-toolbar-title>{{$t('archivedReports')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <!-- <v-card> -->
    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
      <dataTable v-on:clickItem="goToMarker" :items="items" :progress="progress" :headers="headers">
        <template v-slot:cardContent="{item}">
          <v-subheader class="subheading primary lighten-3 white--text font-weight-bold">
            <a href="#" class="white--text" @click="goToMarker(item)">{{item.project}} > {{item.buildingComponent}} > {{item.blueprint }} > {{item.marker}}</a>
            <v-spacer></v-spacer>
          </v-subheader>

          <v-divider></v-divider>
          <div v-ripple class="pointer" @click="goToMarker(item)">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>{{$t('name')}} & {{$t('company')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.name }} {{item.company}}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>{{$t('email')}}/ {{$t('phone')}}:</v-list-item-content>
                <v-list-item-content
                  class="align-end font-weight-bold"
                >{{ item.email }}</v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>{{$t('createdTs')}}:</v-list-item-content>
                <v-list-item-content class="align-end font-weight-bold">{{ item.dateFormated }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </template>
        <template v-slot:empty>
          <retry v-on:retry="getData()" v-if="retry"></retry>
          <!-- <emptyList
            :image="require('@/assets/buildings_logo_low_opacity.png')"
            :title="$t('noProjects')"
            v-else
          >
            <template v-slot:action>
              <can I="create" a="projects">
                <addProject v-on:add-project="addProject"></addProject>
              </can>
            </template>
          </emptyList> -->
        </template>
      </dataTable>
    </div>
    <!-- </v-card> -->
    <loadingDialog :dialog="loading"></loadingDialog>
  </div>
</template>

<script>
import retry from "@/components/Retry";
import emptyList from "@/components/EmptyList";
import dataTable from "@/components/Datatable";

import { validationMixin } from "vuelidate";

export default {
  name: "OldReports",
  components: {
    retry,
    emptyList,
    dataTable
  },
  data() {
    return {
      progress: true,
      items: [],
      headers: null,
      loading: false,
      search: "",
      sortDesc: false,
      retry: false
    };
  },
  methods: {
    goToMarker(item) {
      this.$router.push({ name: "MarkerDetails", params: { id: item.markerId } });
    },
    buildHeaders() {
     
        this.headers = [
          {
            text: this.$t("name"),
            align: "left",
            value: "name"
          },
          { text: this.$t("email"), value: "email" },
          {
            text: this.$t("project"),
            value: "project"
          },
          { text: this.$t("date"), value: "dateFormated" }
        ];
    
    },
    getData() {
      this.progress = true;
      this.$http
        .getOldReports()
        .then(res => {
          this.items = res.data;
          this.progress = false;
          this.retry = false;
        })
        .catch(error => {
          this.progress = false;
          this.retry = true;
          console.log(error.response.status);
        });
    }
  },
  created() {
    this.getData();
    this.buildHeaders();
    this.$store.state.previous = null;
    this.$store.state.breadcrumb = null;
  }
};
</script>


// WEBPACK FOOTER //
// src/views/reports/oldReports.vue